import axios from 'axios';

export class RequestService {
    public static async get(uri: string, data: any = {}): Promise<any> {
        if (Object.keys(data).length > 0) {
            uri = `${uri}${ uri.indexOf('?') === -1 ? '?' : '&' }${this.qs(data)}`;
        }
    
        return axios.get(uri, {
            headers: this.getHeaders(),
            withCredentials: true
        });
    };

    public static async delete(uri: string, data: any): Promise<any>  {
        return axios.delete(uri, {
            data,
            headers: this.getHeaders(),
            withCredentials: true
        });
    };

    public static async post(uri: string, data: any): Promise<any>  {
        return axios.post(uri, data, {
            headers: this.getHeaders(),
            withCredentials: true
        });
    };

    public static async put(uri: string, data: any): Promise<any>  {
        return axios.put(uri, data, {
            headers: this.getHeaders(),
            withCredentials: true
        });
    };

    public static async patch(uri: string, data: any): Promise<any>  {
        return axios.patch(uri, data, {
            headers: this.getHeaders(),
            withCredentials: true
        });
    };

    public static async upload(uri: string, data: any): Promise<any>  {
        return axios.post(uri, data, {
            headers: this.getHeaders(true),
            withCredentials: true
        });
    };

    private static getHeaders(multipart = false): any {
        let defaultHeaders = {};
      
        if (multipart) {
            defaultHeaders = {
                'Content-Type': 'multipart/form-data'
            };
        }
      
        return defaultHeaders;
    }

    private static qs(params: any): string {
        let qs = '';
        Object.keys(params).forEach(k => {
            const key = k, value = params[k];
            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    const currentValue = value[i];
                    if (typeof currentValue === 'object' && !Array.isArray(currentValue) && currentValue !== null) {
                        Object.keys(currentValue).forEach(k => {
                            qs = `${qs}&${encodeURIComponent(key)}${encodeURIComponent(`[${i}]`)}.${encodeURIComponent(k)}=${encodeURIComponent(currentValue[k])}`;
                        });
                    } else {
                        qs = `${qs}&${encodeURIComponent(key)}${encodeURIComponent(`[${i}]`)}=${encodeURIComponent(currentValue)}`;
                    }
                }
            } else {
                qs = `${qs}&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            }
        });
    
        return qs.substring(1);
    }
}